module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("系统设置")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("硬件绑定")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle-switch"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.submit
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("是否启用硬件绑定")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0e39a00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/system.vue
// module id = 1826
// module chunks = 9